module.exports = __webpack_public_path__ + "assets/img/result_none.ad802c11.png";